export const DEBOUNCE_DURATION = 500;
export const FILTERS_SET_FILTER_LIST_ANCHOR_EL_ID = 'FILTERS_SET_FILTER_LIST_ANCHOR_EL_ID';
export const FILTERS_SET_FILTER_ANCHOR_EL_ID = 'FILTERS_SET_FILTER_ANCHOR_EL_ID';
export const FILTERS_SET_FILTER_MENU_VISIBILITY = 'FILTERS_SET_FILTER_MENU_VISIBILITY';
export const FILTERS_SET_POPPER_IS_OPEN = 'FILTERS_SET_POPPER_IS_OPEN';
export const FILTERS_SET_PROJECT_FILTER_DATA = 'FILTERS_SET_PROJECT_FILTER_DATA';
export const FILTERS_SET_PEOPLE_FILTER_DATA = 'FILTERS_SET_PEOPLE_FILTER_DATA';
export const FILTERS_SET_HOURLY_PERSON_FILTER_DATA = 'FILTERS_SET_HOURLY_PERSON_FILTER_DATA';
